import type { AddFlagProps } from '@databases/flags-types';

import type { ContentTypesFlagProps } from '@canvas/frame-api-types';

import { MentionFlagForMultipleUsers } from './mentionFlagForMultipleUsers.tsx';
import { MentionFlagForSingleUser } from './mentionFlagForSingleUser.tsx';
import { MentionFlagForTwoUsers } from './mentionFlagForTwoUsers.tsx';
import { RestrictionsFlagForMultipleUsers } from './restrictionsFlagForMultipleUsers.tsx';
import { RestrictionsFlagForSingleUser } from './restrictionsFlagForSingleUser.tsx';
import { RestrictionsFlagForTwoUsers } from './restrictionsFlagForTwoUsers.tsx';
import { type MentionBuilder, type BuildProps } from './types.ts';

const MentionBuilderClasses: { new (props: BuildProps): MentionBuilder }[] = [
  MentionFlagForMultipleUsers,
  MentionFlagForSingleUser,
  MentionFlagForTwoUsers,
  RestrictionsFlagForMultipleUsers,
  RestrictionsFlagForSingleUser,
  RestrictionsFlagForTwoUsers
];

export function buildFlagForMentions(
  props: BuildProps
): (AddFlagProps & ContentTypesFlagProps)[] {
  const flagData = [];
  for (const MentionBuilder of MentionBuilderClasses) {
    const mentionBuilder = new MentionBuilder(props);

    if (!mentionBuilder.shouldShowFlag()) {
      continue;
    }

    const buildFlagData = mentionBuilder.build();

    flagData.push({
      ...buildFlagData,
      close: 'auto' as const
    });
  }

  return flagData;
}
